import '@mantine/core/styles/global.css';
import 'theme/stylesheets/reset.css';
import 'theme/stylesheets/about_us.css';
import 'theme/stylesheets/add-group-modal.css';
import 'theme/stylesheets/billing-transaction.css';
import 'theme/stylesheets/chart.css';
import 'theme/stylesheets/common.css';
import 'theme/stylesheets/company.css';
import 'theme/stylesheets/erp-account.css';
import 'theme/stylesheets/feed.css';
import 'theme/stylesheets/icon.css';
import 'theme/stylesheets/landing_nav.css';
import 'theme/stylesheets/mobile.css';
import 'theme/stylesheets/our_product.css';
import 'theme/stylesheets/overlay-trigger.css';
import 'theme/stylesheets/password-change-modal.css';
import 'theme/stylesheets/plan.css';
import 'theme/stylesheets/policy-approver-flow.css';
import 'theme/stylesheets/policy-members.css';
import 'theme/stylesheets/policy-refund.css';
import 'theme/stylesheets/policy-setting.css';
import 'theme/stylesheets/policy_upload_modal.css';
import 'theme/stylesheets/report.css';
import 'theme/stylesheets/report_plan.css';
import 'theme/stylesheets/scraping.css';
import 'theme/stylesheets/sign_in.css';
import 'theme/stylesheets/simple-select.css';
import 'theme/stylesheets/style.css';
import 'theme/stylesheets/tag.css';
import 'theme/stylesheets/transaction-upload.css';
import 'theme/stylesheets/user_card.css';
import 'theme/stylesheets/web-view.css';
import 'react-image-lightbox/style.css';
import '@mantine/core/styles.css';

import ReactDOM from 'react-dom';
import { Router } from 'react-router-dom';

import { MantineProvider } from '@mantine/core';
import { enableMapSet, setAutoFreeze } from 'immer';
import { NuqsAdapter } from 'nuqs/adapters/react';
import { OverlayProvider } from 'overlay-kit';
import { CookiesProvider } from 'react-cookie';
import { QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import { attachNetworkStateListeners } from '@/new_src/view/bootstrap/config/attachGlobalListeners';
import { spenditHistory } from '@/new_src/view/bootstrap/config/configureHistory';
import configureQueryClient from '@/new_src/view/bootstrap/config/configureQueryClient';
import applyPolyfills from '@/new_src/view/bootstrap/config/polyfill';
import { Entry } from '@/new_src/view/bootstrap/Entry';
import { ModalManager } from '@/new_src/view/components/Modal';
import { AppModal } from '@/new_src/view/components/WebView/AppModal';
import { OktaSecurityProvider } from '@/new_src/view/pages/SSO/Okta';

import { configureAxios } from 'apis/API';
// import { createRoot } from 'react-dom/client';
import { initAxiosConfig } from 'apis/bootstrap';
import DatadogLogUtil from 'utils/DatadogLogUtil';
import { DEFAULT_LANGUAGE, setLocale } from 'utils/LocaleUtil';

import SentryUtil from './utils/SentryUtil';

import { ThemeProvider } from 'styled-components';
import { GlobalPrintPageStyle, GlobalStyle } from '@/theme/globalStyle';

if (process.env.REACT_APP_ENV === 'development.local') {
  /**
   * MSW Worker. 기본적으로 미사용. 필요할 때만 주석 해제하여 사용.
   */
  // mockWorker.start();
}

setLocale(DEFAULT_LANGUAGE).then(async () => {
  /**
   * @todo this.state를 직접 수정하는 코드들이 수정되면 제거
   */
  setAutoFreeze(false);
  enableMapSet();
  applyPolyfills();

  // Locale이 로드된 이후에 import
  const { TaskCardList } = await import('./components/commons/TaskCardList');

  const { defaultTheme, mantineTheme } = await import('theme');
  const { ErrorBoundary } = await import('@/new_src/view/bootstrap/ErrorBoundary');
  const { LoadingSpinner } = await import('./components/utility/LoadingSpinner');
  const { configureStore } = await import('@/new_src/view/bootstrap/config/configureStore');

  SentryUtil.initSentry();
  const { store, persistor } = configureStore();
  const { queryClient } = configureQueryClient();

  initAxiosConfig(store);
  configureAxios(store);
  attachNetworkStateListeners(store);

  const App = () => {
    return (
      <ThemeProvider theme={defaultTheme}>
        <MantineProvider theme={mantineTheme}>
          <GlobalStyle />
          <GlobalPrintPageStyle />
          <ErrorBoundary>
            <CookiesProvider>
              <Provider store={store}>
                <PersistGate loading={<LoadingSpinner />} persistor={persistor}>
                  <NuqsAdapter>
                    <Router history={spenditHistory}>
                      <QueryClientProvider client={queryClient}>
                        <OverlayProvider>
                          <ModalManager.ModalsProvider modals={{ webView: AppModal }}>
                            <OktaSecurityProvider>
                              <Entry />
                            </OktaSecurityProvider>
                          </ModalManager.ModalsProvider>
                        </OverlayProvider>
                        <ReactQueryDevtools initialIsOpen={false} />
                      </QueryClientProvider>
                    </Router>
                  </NuqsAdapter>
                  <TaskCardList />
                </PersistGate>
              </Provider>
            </CookiesProvider>
          </ErrorBoundary>
        </MantineProvider>
      </ThemeProvider>
    );
  };

  DatadogLogUtil.init();

  // React 17 render 메서드로 변경
  ReactDOM.render(<App />, document.getElementById('root'));
  // const container = document.getElementById('root');
  // const root = createRoot(container);
  // root.render(<App />);
});
